import React from "react";
import Button from "@material-ui/core/Button";
import DialogNew from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

type Action = {
  label: string;
  onClick: (e: React.MouseEvent) => void;
  primary?: boolean;
  focus?: boolean;
};

const styles: Record<string, React.CSSProperties> = {
  dialog: {
    zIndex: 99999,
  },
  dialogActionsContainerStyle: {
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "flex-start",
  },
  dialogContentStyle: {
    width: "400px",
    maxWidth: "400px",
  },
};

export const NewDialog = ({
  title,
  open,
  onRequestClose,
  message,
  actions,
}: {
  title: string;
  open: boolean;
  onRequestClose: () => void;
  message: string;
  actions: Action[];
}) => (
  <DialogNew style={styles.dialog} open={open} onClose={onRequestClose}>
    {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
    <DialogContent style={styles.dialogContentStyle}>{message}</DialogContent>
    <DialogActions style={styles.dialogActionsContainerStyle}>
      {actions.map((action, index) => {
        return (
          <Button
            // action={(button) => {
            //   action.focus && button && button.focusVisible();
            // }}
            key={index}
            color={action.primary ? "primary" : "default"}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        );
      })}
    </DialogActions>
  </DialogNew>
);
